module.exports = __webpack_public_path__ + "assets/637bf96f5af446bde8626dce3057d0e0.mp3";